import { render, staticRenderFns } from "./dialogbox.vue?vue&type=template&id=5c178598&scoped=true"
import script from "./dialogbox.vue?vue&type=script&lang=js"
export * from "./dialogbox.vue?vue&type=script&lang=js"
import style0 from "./dialogbox.vue?vue&type=style&index=0&id=5c178598&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c178598",
  null
  
)

export default component.exports